import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  PAYMENT_TERMS_SECTIONS,
  PAYMENT_TERMS_SUBTITLE,
  PAYMENT_TERMS_TITLE,
} from '@/content/legal/payment-terms';
import { resolveLegalReturnTo } from '@/features/legal/legal-navigation';
import { MiniappSurface } from '@/shared/components/ui/MiniappSurface';
import { PageFrame } from '@/shared/components/ui/PageFrame';
import { StackHeader } from '@/shared/components/ui/StackHeader';

export function PaymentTermsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = resolveLegalReturnTo(location.search, '/legal');

  const handleBack = useCallback(() => {
    void navigate(returnTo);
  }, [navigate, returnTo]);

  return (
    <PageFrame
      container="readable-content"
      topInset="stack"
      bottomInset="none"
      className="space-y-4 pb-6"
    >
      <StackHeader onBack={handleBack} label="Документы" title="Оплата и возврат" />

      <MiniappSurface className="space-y-4 px-5 py-5">
        <div className="space-y-2">
          <h1 className="text-[24px] font-black uppercase leading-[0.92] tracking-[0.02em] text-[var(--foreground)]">
            {PAYMENT_TERMS_TITLE}
          </h1>
          <p className="text-[14px] leading-6 text-[rgba(26,26,26,0.62)]">
            {PAYMENT_TERMS_SUBTITLE}
          </p>
          <p className="text-[13px] leading-5 text-[rgba(26,26,26,0.58)]">
            Краткая информация о том, как предоставляется доступ после оплаты и как подать заявку на
            возврат денежных средств.
          </p>
        </div>
      </MiniappSurface>

      {PAYMENT_TERMS_SECTIONS.map((section) => (
        <MiniappSurface key={section.title} className="space-y-3 px-5 py-5">
          <h2 className="text-[16px] font-black uppercase tracking-[0.02em] text-[var(--foreground)]">
            {section.title}
          </h2>

          <div className="space-y-3 text-[14px] leading-6 text-[rgba(26,26,26,0.74)]">
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}

            {section.bullets && (
              <ul className="space-y-2">
                {section.bullets.map((bullet) => (
                  <li key={bullet} className="flex gap-2">
                    <span className="pt-[0.35rem] text-[var(--accent)]">•</span>
                    <span>{bullet}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </MiniappSurface>
      ))}
    </PageFrame>
  );
}
